import { buildBinningBase } from "./binning";
import { TIME_WINDOW_IN_MINUTES } from "./constants";
import { roundDateToNearestMinutes } from "./helpers";
import { BinStrategyBuilder } from "./strategy-builder";
import { CURATED_INVENTORY_SOURCES } from "../../../../constants/sources";

export type BinnableLeg = {
  id: string;
  price_in_cents: number;
  departure_time: string;
  operator_id?: string | number;
  source_name?: string | number;
  is_external?: boolean;
  origin_id: string;
  destination_id: string;
};

export const buildBinByTimeWindowStrategy = <
  T extends { departure_time: string }
>(
  time_window_minutes: number
) =>
  buildBinningBase<T>(value => {
    const rounded_date = roundDateToNearestMinutes(
      value.departure_time,
      time_window_minutes
    );
    return rounded_date.getTime() / 1000;
  });

export const binByPrice = buildBinningBase(
  (value: BinnableLeg) => value.price_in_cents
);

export const buildBoxWhenNecessaryStrategy = (
  source_names: string[],
  time_window_minutes: number
) =>
  BinStrategyBuilder<BinnableLeg, string, string[]>()
    .binBy(value => {
      const rounded_date = roundDateToNearestMinutes(
        value.departure_time,
        time_window_minutes
      );
      return `${value.origin_id}-${value.destination_id}-${
        rounded_date.getTime() / 1000
      }`;
    })
    .createFilter(filter =>
      filter
        .setKey("id")
        .filterBy({
          source_name: {
            $in: source_names
          }
        })
        .setLimit.filtered(0, {
          $empty: 1
        })
        .transform((_, ctx) => Array.from(ctx.excluded_results_set))
    )
    .orderBy({ price_in_cents: "desc" })
    .format.results(results => results.flat())
    .build();

export const boxWhenNecessaryStrategy = buildBoxWhenNecessaryStrategy(
  CURATED_INVENTORY_SOURCES,
  TIME_WINDOW_IN_MINUTES
);
